export default "__VITE_ASSET__GeSMqUT$__"